<ngx-spinner bdColor="rgba(0, 0, 0, 0)" template=" <img src='assets/images/spinner.gif' />">
  <!-- <p style="color: white;">{{ spinnerText }}</p> -->
</ngx-spinner>
<!-- <router-outlet></router-outlet> -->
<section class="home-content">
  <div class="content-top-box">
    <app-bread-crumb></app-bread-crumb>
  </div>

  <!-- <h1 class="main-title">Home</h1> -->
  <ul class="menu-card-list">
    <li class="list-items" *ngFor="let cardItem of homeCardList">
      <a class="list-link"  [routerLink]="cardItem?.route" [id]="cardItem?.menuId"
        (click)="displayRightmenu(cardItem.menuId, cardItem.route, cardItem?.type, cardItem)" [ngClass]="{'disabled': false}" #cardPin>
        <div class="link-top-box">
          <div class="box-bg">
            <svg width="62" height="68" viewBox="0 0 62 68" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M25 2.4641C28.7128 0.320509 33.2872 0.320508 37 2.4641L55.3109 13.0359C59.0237 15.1795 61.3109 19.141 61.3109 23.4282V44.5718C61.3109 48.859 59.0237 52.8205 55.3109 54.9641L37 65.5359C33.2872 67.6795 28.7128 67.6795 25 65.5359L6.68911 54.9641C2.9763 52.8205 0.689112 48.859 0.689112 44.5718V23.4282C0.689112 19.141 2.9763 15.1795 6.68911 13.0359L25 2.4641Z"
                fill="#10CE9C" />
            </svg>
          </div>
          <div class="top-icon">
            <img [src]="'assets/Content/Icon/' + cardItem.icon" [alt]="cardItem.label" width="32">
          </div>
        </div>
        <p class="link-text">{{getTransalatedValue(cardItem.label)}}</p>
        <div class="link-bottom-icon">
          <svg width="92" height="90" viewBox="0 0 92 90" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M91.75 19.8272L60.6117 1.87771L60.6095 1.87643C56.2357 -0.624871 50.8652 -0.626576 46.5257 1.87791L7.04595 24.6358L7.04486 24.6364C2.66499 27.1417 0 31.7929 0 36.8358V82.3546C0 85.0234 0.756402 87.5685 2.10894 89.75H3.91591C2.37415 87.636 1.5 85.0649 1.5 82.3546V36.8358C1.5 32.324 3.88287 28.1727 7.79061 25.9379L7.79284 25.9366L47.2752 3.17726L47.2755 3.17707C51.1486 0.941774 55.9495 0.93988 59.8638 3.17797L59.8648 3.17854L91.75 21.5586V19.8272ZM67.6178 89.75C78.9857 84.4572 86.8692 72.9422 86.8692 59.5952C86.8692 41.2358 71.9525 26.3426 53.5689 26.3426C35.1852 26.3426 20.2686 41.2358 20.2686 59.5952C20.2686 72.9422 28.1521 84.4572 39.5199 89.75H43.585C30.9156 85.5672 21.7686 73.6425 21.7686 59.5952C21.7686 42.0663 36.0116 27.8426 53.5689 27.8426C71.1262 27.8426 85.3692 42.0663 85.3692 59.5952C85.3692 73.6425 76.2222 85.5672 63.5527 89.75H67.6178Z"
              fill="#10CE9C" />
            <path class="arrow-box"
              d="M69 68C69 72.4183 65.4183 76 61 76L47 76C42.5817 76 39 72.4183 39 68L39 54C39 49.5817 42.5817 46 47 46L61 46C65.4183 46 69 49.5817 69 54L69 68Z"
              fill="white" />
            <path class="arrow"
              d="M53.9967 54L52.8217 55.175L57.4717 59.8333H47.3301V61.5H57.4717L52.8217 66.1583L53.9967 67.3333L60.6634 60.6667L53.9967 54Z"
              fill="#10CE9C" />
          </svg>
        </div>
      </a>
      <p-contextMenu [target]="cardPin" [model]="items" (click)="makeItFavorite(cardItem)"></p-contextMenu>
    </li>
  </ul>
</section>
<!-- <h1 *ngIf="homeCardList?.length === 0" style="text-align:center; font-size: 50px;">Module Under Construction</h1> -->
<div class=container4 *ngIf="homeCardList?.length === 0">

  <p> The User Does Not Have Access to Menu!
</div>

<!-- Shift Start Template-->
<ng-template #displayShiftStartModal>
  <div class="card">
    <h1 class="card-header">
      <strong style="color: #ffff;">Shift Start</strong>
    </h1>
  </div>
  <div class="top-row">
    <div class="notication-icon">
      <img src="assets/images/bell.png">
    </div>
    <div class="title">
      <p>Welcome to O3 Manufacturing Mr. {{userName}}</p>
    </div>
  </div>
  <table mat-table class="basic-table plant-model-table" matSort [dataSource]="shiftStartDataSource">
    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef class="header-min-width">
        <p class="header-text"> Date</p>
      </th>
      <td mat-cell *matCellDef="let element">{{element?.Date | date: 'YYYY-MM-dd HH:mm:ss' }}</td>
    </ng-container>
    <!-- Shift Start Column -->
    <ng-container matColumnDef="shiftstart">
      <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef class="header-min-width">
        <p class="header-text"> Shift Start</p>
      </th>
      <td mat-cell *matCellDef="let element">{{element?.ShiftStart | date: 'YYYY-MM-dd HH:mm:ss' }}</td>
    </ng-container>
    <ng-container matColumnDef="shiftend">
      <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef class="header-min-width">
        <p class="header-text"> Shift End</p>
      </th>
      <td mat-cell *matCellDef="let element">{{element?.ShiftEnd | date: 'YYYY-MM-dd HH:mm:ss' }}</td>
    </ng-container>
    <!-- Shift Column -->
    <ng-container matColumnDef="shift">
      <th mat-header-cell *matHeaderCellDef>
        <p class="header-text"> Shift</p>
      </th>
      <td mat-cell *matCellDef="let element">{{element?.ShiftDesc}}</td>
    </ng-container>
    <!-- Machine Column -->
    <ng-container matColumnDef="machine">
      <th mat-header-cell *matHeaderCellDef>
        <p class="header-text">Machine</p>
      </th>
      <td mat-cell *matCellDef="let element">{{element?.Machine}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="shiftcloseColumns"></tr>
    <tr class="mat-row" *matNoDataRow style="text-align: center;">
      <td class="mat-cell" colspan="8">No data matching</td>
    </tr>
    <tr mat-row *matRowDef="let row; columns: shiftcloseColumns;"
      [ngClass]="{highlighted: selectedRowIndex == row.CrewId}" (click)="highlightedRow(row)"></tr>
  </table>
  <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  <div class="title">
    <p>Please do Shift Start to proceed further!</p>
  </div>
  <div style="display: flex; justify-content: center;">
    <button type="submit" mat-flat-button color="accent" class="btn-accent btn-lg submit-btn"
      (click)="SubmitShiftStart()">
      Shift Start
    </button>
  </div>
</ng-template>

<ng-template #resetModalContent>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>Password Reset</h2>
    </div>
  </div>
  <hr>
  <mat-dialog-content style="height: auto">
    <form [formGroup]="resetPasswordForm" (ngSubmit)="changePassword()">
      <div class="form-group" style="margin-top: 10px;">
        <h5 *ngIf="isDisabled" style="color: red">* First validate old password to reset password</h5>
        <mat-form-field [ngClass]="{
          'is-invalid':
          resetPasswordForm.get('oldPassword')?.errors &&
          resetPasswordForm.get('oldPassword')?.touched
        }" appearance="fill" class="field-fill">
          <mat-label>Validate Old Password<span class="required"></span></mat-label>
          <input matInput type="password" placeholder="enter old password"
            formControlName="oldPassword" [readonly]="!isDisabled" required>
        </mat-form-field>
        <p class="invalid-feedback" *ngIf="
      resetPasswordForm.get('oldPassword')?.touched &&
      resetPasswordForm.get('oldPassword')?.hasError('required')">
          * old password is required!
        </p>
        <h4 *ngIf="!isDisabled" style="color: rgb(16, 206, 156)">* Old password validated</h4>
      </div>
      <div style="display: flex;">
        <div class="form-group" style="margin-right: 20px;">
          <mat-form-field [ngClass]="{
            'is-invalid':
            resetPasswordForm.get('Password')?.errors &&
            resetPasswordForm.get('Password')?.touched
          }" appearance="fill" class="field-fill">
            <mat-label>New Password<span class="required"></span></mat-label>
            <input matInput type="password" placeholder="enter password" formControlName="Password"
              [readonly]="isDisabled" required>
          </mat-form-field>
          <p class="invalid-feedback" *ngIf="
        
        resetPasswordForm.get('Password')?.hasError('required')">
            * password is required!
          </p>
          <p class="invalid-feedback" *ngIf="
            
            resetPasswordForm.get('Password')?.hasError('minlength')">
            * Must be at least {{minimumLength}} characters!
          </p>
          <p class="invalid-feedback" *ngIf="
            
            resetPasswordForm.get('Password')?.hasError('hasNumber')">
            * Must contain at least 1 number!
          </p>
          <p class="invalid-feedback" *ngIf="
            
            resetPasswordForm.get('Password')?.hasError('hasCapitalCase')">
            * Must contain at least 1 in Capital Case!
          </p>
          <p class="invalid-feedback" *ngIf="
            
            resetPasswordForm.get('Password')?.hasError('hasSmallCase')">
            * Must contain at least 1 Letter in Small Case!
          </p>
          <p class="invalid-feedback" *ngIf="
            
            resetPasswordForm.get('Password')?.hasError('hasSpecialCharacters')">
            * Must contain at least 1 Special Character!
          </p>
        </div>
        <div class="">
          <mat-form-field [ngClass]="{
            'is-invalid':
            resetPasswordForm.get('confirmpassword')?.errors &&
            resetPasswordForm.get('confirmpassword')?.touched
          }" appearance="fill" class="field-fill">
            <mat-label>Confirm Password<span class="required"></span></mat-label>
            <input matInput type="password" placeholder="confirm password" formControlName="confirmpassword"
              [readonly]="isDisabled" required>
          </mat-form-field>
          <p class="invalid-feedback" *ngIf="
          resetPasswordForm.get('confirmpassword')?.touched &&
          resetPasswordForm.get('confirmpassword')?.hasError('required')">
            * confirm password is required
          </p>
          <p class="invalid-feedback" *ngIf="
            resetPasswordForm.get('confirmpassword')?.hasError('NoPassswordMatch') &&
            resetPasswordForm.get('confirmpassword')?.touched
            ">
            * password and confirm password does not match
          </p>
        </div>
      </div>
      <div style="float:right;margin-bottom: 10px;">
        <button class="mat-raised-button " [ngClass]="!resetPasswordForm.valid ? 'disableClr' : 'mat-primary'"
          [disabled]="!resetPasswordForm.valid" type="submit">Change Password</button>
      </div>
    </form>
  </mat-dialog-content>

</ng-template>